module.exports = __webpack_public_path__ + "static/media/Warning_two.7e6f49c9.svg";